<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
    <path fill="currentColor" fill-rule="evenodd" d="M5.66667 16c0-.5523.44771-1 1-1H25.3333c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.66667c-.55229 0-1-.4477-1-1z" clip-rule="evenodd" />
    <path fill="currentColor" fill-rule="evenodd" d="M16.7071 5.95955c.3905.39052.3905 1.02369 0 1.41421L8.08088 16l8.62622 8.6262c.3905.3905.3905 1.0237 0 1.4142-.3905.3906-1.0237.3906-1.4142 0l-9.33334-9.3333c-.39052-.3905-.39052-1.0237 0-1.4142l9.33334-9.33335c.3905-.39052 1.0237-.39052 1.4142 0z" clip-rule="evenodd" />
  </svg>
</template>
